'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Heading } from '../heading/heading.js';

/**
 * ErrorSummary heading component, used to display a heading for the error summary.
 *
 * @example
 * <ErrorSummary>
 *   <ErrorSummaryHeading>Heading</ErrorSummaryHeading>
 * </ErrorSummary>
 */
const ErrorSummaryHeading = forwardRef(function ErrorSummaryHeading(rest, ref) {
    return jsx(Heading, { ref: ref, suppressHydrationWarning: true, ...rest }); // Suppress hydration warning since we will get an ID from <ds-error-summary>
});

export { ErrorSummaryHeading };
